export default "__VITE_ASSET__C752bn2J__"